import React, { useEffect } from 'react';
import Box from '~/components/Box';
import DefaultLayout from '~/pages/_layouts/full';
import PageTitle from '~/components/PageTitle';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from 'antd';
import { BreadcrumbCustom } from '~/styles/global';

export default function SystemConfig() {
  const { t } = useTranslation();

  useEffect(() => {
    
  }, []);

  const breadcrumb = 
    <BreadcrumbCustom>
      <Breadcrumb.Item href="/">{t('menus:home')}</Breadcrumb.Item>
      <Breadcrumb.Item>{t('menus:settings')}</Breadcrumb.Item>
    </BreadcrumbCustom>
  ;

  return (
    <DefaultLayout breadcrumb={breadcrumb}>
      <Box>
        <PageTitle title={t('menus:settings')} />
      </Box>
    </DefaultLayout>
  );
}
